/*
 * @Description: 新增、编辑人员对话框中各面板共用的数据
 * @Author: wanqian
 * @Date: 2021-06-11 13:13:43
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
    mode: '',
    attendantDo: null,
    idCardImgFrontFile: null,
    idCardImgBackFile: null,
    attendant: null,
    isIdNoRepeat: false,
    attendantPrivilege: null,
}

const mutations = {
    changeMode(stateN, mode) {
        stateN.mode = mode;
    },

    changeIdCardImgFrontFile(stateN, idCardImgFrontFile) {
        stateN.idCardImgFrontFile = idCardImgFrontFile;
    },

    changeIdCardImgBackFile(stateN, idCardImgBackFile) {
        stateN.idCardImgBackFile = idCardImgBackFile;
    },

    changeAttendant(stateN, attendant) {
        stateN.attendant = attendant;
    },

    changeIsIdNoRepeat(stateN, isIdNoRepeat) {
        stateN.isIdNoRepeat = isIdNoRepeat;
    },

    changeAttendantDo(stateN, attendantDo) {
        stateN.attendantDo = attendantDo;
    },

    changeAttendantPrivilege(stateN, attendantPrivilege) {
        stateN.attendantPrivilege = attendantPrivilege;
    },
}

export default new Vuex.Store({
    state: state,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/components/instmng/components/attendantdetails/AttendantStore.js